import { t } from "ttag";

import { SettingsPageWrapper } from "metabase/admin/components/SettingsSection";
import { UpsellSSO } from "metabase/admin/upsells";
import { useGetSettingsQuery } from "metabase/api";
import { hasAnySsoFeature } from "metabase/common/utils/plan";
import {
  type AuthSettingsPageTab,
  PLUGIN_AUTH_PROVIDERS,
} from "metabase/plugins";
import { Box, Flex, Stack } from "metabase/ui";

import { ApiKeysAuthCard } from "../../auth/components/ApiKeysAuthCard";
import { PersonalAccessTokensAuthCard } from "../../auth/components/PersonalAccessTokensAuthCard";
import { GoogleAuthCard } from "../../auth/containers/GoogleAuthCard/GoogleAuthCard";
import { LdapAuthCard } from "../../auth/containers/LdapAuthCard";
import { SamlAuthCard } from "../../auth/containers/SamlAuthCard";
import { ManageApiKeys } from "../ApiKeys/ManageApiKeys";
import { ManagePersonalAccessTokens } from "../PersonalAccessTokens/ManagePersonalAccessTokens";

export function AuthenticationSettingsPage({
  tab,
}: {
  tab: AuthSettingsPageTab;
}) {
  const hasSSO = useHasSso();

  if (hasSSO) {
    return <PLUGIN_AUTH_PROVIDERS.AuthSettingsPage tab={tab} />;
  }

  if (tab === "api-keys") {
    return <ManageApiKeys />;
  }

  if (tab === "personal-access-tokens") {
    return <ManagePersonalAccessTokens />;
  }

  return (
    <SettingsPageWrapper title={t`Authentication`}>
      <Flex justify={"space-between"} gap="lg">
        <Stack gap="lg">
          <GoogleAuthCard />
          <LdapAuthCard />
          <SamlAuthCard />
          <ApiKeysAuthCard />
          <PersonalAccessTokensAuthCard />
        </Stack>
        <Box style={{ flexShrink: 0 }}>
          <UpsellSSO location="authentication-sidebar" />
        </Box>
      </Flex>
    </SettingsPageWrapper>
  );
}

const useHasSso = () => {
  const { data: settings } = useGetSettingsQuery();

  const tokenFeatures = settings?.["token-features"];
  return hasAnySsoFeature(tokenFeatures);
};
